import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";

import React, { useEffect, useState } from "react";
import { Box, Checkbox, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import IpCidrInputField from "components/InputField/IpCidrInputField";

const IpAddressTableRow = ({
  ip,
  form,
  index,
  isSelected,
  onSelect,
  onIpChange,
  onDescChange,
}) => {
  const theme = useTheme();
  const [isDirty, setIsDirty] = useState(false);
  const [isIpError, setIsIpError] = useState(false);
  const [isSubnetError, setIsSubnetError] = useState(false);

  const isSubnetValid = (value) => {
    if (value === "" || value === null || value === undefined) return false;
    if (!/^\d{1,2}$/.test(value)) return false;
    const numberValue = Number(value);
    return numberValue >= 0 && numberValue <= 32;
  };

  useEffect(() => {
    setIsIpError(!form.validateIpAddress(ip.ipAddress || ""));
    setIsSubnetError(!isSubnetValid(ip.subnet));
  }, [ip.ipAddress, ip.subnet, form]);

  const cellSx = {
    verticalAlign: "top",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  const controlRowSx = {
    minHeight: "42px",
    display: "flex",
    alignItems: "center",
  };

  return (
    <TableRow>
      <TableCell sx={{ ...cellSx, width: "48px" }}>
        <Box sx={controlRowSx}>
          <Checkbox
            icon={<CheckDefIcon width="25px" height="25px" />}
            checkedIcon={<CheckFillIcon width="25px" height="25px" />}
            checked={isSelected}
            onChange={() => onSelect(index)}
          />
        </Box>
      </TableCell>
      <TableCell sx={{ ...cellSx, width: "360px" }}>
        <Box>
          <Box sx={controlRowSx}>
            <IpCidrInputField
              ipAddress={ip.ipAddress}
              subnet={ip.subnet}
              onChange={({ ipAddress, subnet }) => {
                setIsDirty(true);
                onIpChange(index, { ipAddress, subnet });
              }}
              onBlur={() => setIsDirty(true)}
              error={isDirty && (isIpError || isSubnetError)}
            />
          </Box>
          {isDirty && isIpError && (
            <Typography
              sx={{
                color: theme.palette.primary.redPrimary,
                fontSize: "12px",
                lineHeight: "18px",
                marginTop: "3px",
              }}
            >
              Invalid format
            </Typography>
          )}
          {isDirty && !isIpError && isSubnetError && (
            <Typography
              sx={{
                color: theme.palette.primary.redPrimary,
                fontSize: "12px",
                lineHeight: "18px",
                marginTop: "3px",
              }}
            >
              0-32
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell sx={{ ...cellSx }}>
        <Box sx={controlRowSx}>
          <TextField
            value={ip.description}
            sx={form.getTextfieldStyle(true)}
            fullWidth
            onChange={(e) => onDescChange(index, e.target.value)}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default React.memo(IpAddressTableRow);
